<template>
  <td>{{ url }}</td>
</template>

<script lang="babel">
export default {
  props: ['content', 'model'],
  computed: {
    url() {
      return `${Laravel.domains[0]}?ac=${this.content}`;
    }
  }
};
</script>
